var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolunteer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "{t.volunteers}") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Dashboard---Actions",
    transform: "translate(-50.000000, -262.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "Sidebar",
    transform: "translate(30.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "community",
    transform: "translate(20.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "navIcon",
    id: "icon-community",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15962655,6 C5.8537864,6.1259445 6.37859165,6.27870245 6.77529318,6.49518176 C4.51548284,7.32646856 4.09169229,8.68385553 4.01544737,11.9925097 L3.99992486,11.9947419 L3.99992486,11.9947419 C0.588867808,12.0950079 0,10.7280802 0,10.7280802 L0.000956038548,10.543152 C0.00189957357,10.4500336 0.00352262694,10.3494788 0.00574079988,10.2124404 C0.0508256157,7.41540718 0.393710668,6.60361948 2.84016306,6.04765212 C2.84016306,6.04765212 3.18839817,6.55363532 3.99992486,6.53617013 C4.81145154,6.51770052 5.15962655,6 5.15962655,6 Z M4.00002838,1.13686838e-13 C5.7060059,0.00782354541 6,1.12073079 6,2.49068504 C6,3.8606103 5.10453565,4.98417921 4.00002838,4.99984577 C2.89546435,5.015061 2,3.90256341 2,2.51541127 C2,1.12822978 2.29405086,0.00230773474 4.00002838,1.13686838e-13 Z",
    id: "Combined-Shape",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1596265,6 C19.6330697,6.44876776 19.9562978,7.2379732 19.9955216,10.0373479 C19.9980163,10.2163632 19.9993388,10.2472791 20,10.231259 L19.9998497,10.4489085 L19.9998497,10.4489085 C19.9998497,10.4489085 19.4109218,11.8278104 15.9999249,11.9947419 C15.9416103,8.64293165 15.606699,7.23184433 13.534789,6.46009995 C13.8835212,6.29912713 14.3130072,6.16745067 14.8401631,6.04765212 C14.8401631,6.04765212 15.1883982,6.55363532 15.9999249,6.53617013 C16.8114515,6.51770052 17.1596265,6 17.1596265,6 Z M16.0000284,1.13686838e-13 C17.7060059,0.00782354541 18,1.12073079 18,2.49068504 C18,3.8606103 17.1045356,4.98417921 16.0000284,4.99984577 C14.8954644,5.015061 14,3.90256341 14,2.51541127 C14,1.12822978 14.2940509,0.00230773474 16.0000284,1.13686838e-13 Z",
    id: "Combined-Shape",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0909381,6.93605645 C8.96127036,6.9541207 8.04545455,5.63331026 8.04545455,3.98641677 C8.04545455,2.33948845 8.34618838,1.00273985 10.0909381,1 C11.8356879,1.00928849 12.1363636,2.33058529 12.1363636,3.95706061 C12.1363636,5.58350152 11.2205478,6.91745635 10.0909381,6.93605645 Z M14.1772382,11.4513817 C14.1797894,11.6175082 14.1811419,11.6461983 14.1818182,11.6313315 C14.181726,11.6753979 14.1816645,11.7401683 14.1816645,11.8333108 C14.1816645,11.8333108 13.5793767,13.112935 10.0910013,13.2678478 C6.6025644,13.3608948 6.00033812,12.0923828 6.00033812,12.0923828 C6.00033812,11.9437275 6.00015369,11.8584791 6,11.8123927 C6.00067624,11.8369807 6.00242833,11.8258212 6.00620915,11.6138679 C6.05231672,9.01821464 6.40298012,8.2648738 8.9049303,7.74893481 C8.9049303,7.74893481 9.26106513,8.21848839 10.0910013,8.20228065 C10.9209375,8.18514081 11.2770108,7.70471354 11.2770108,7.70471354 C13.8065641,8.12117105 14.1371246,8.8535555 14.1772382,11.4513817 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.e1444150700164861fbc9d835a7b6d02.svg";
export { ForwardRef as ReactComponent };